<template>
<div class="chapter">
<div class="inner_page">
<p class="body_ni"><span>© Noam Chomsky 2002</span></p>
<p class="body_ni"><span>Original edition published by South End Press in Cambridge, Massachusetts</span></p>
<p> </p>
<p class="body_ni"><span>This edition published in 2015 by</span></p>
<p class="body_ni"><span>Haymarket Books</span></p>
<p class="body_ni"><span>P.O. Box 180165</span></p>
<p class="body_ni"><span>Chicago, IL 60618</span></p>
<p class="body_ni"><span>773-583-7884</span></p>
<p class="body_ni"><span>www.haymarketbooks.org</span></p>
<p class="body_ni"><span>info@haymarketbooks.org</span></p>
<p> </p>
<p class="body_ni"><span>ISBN: 978-1-60846-442-5</span></p>
<p> </p>
<p class="body_ni"><span>Trade distribution:</span></p>
<p class="body_ni"><span>In the US, Consortium Book Sales and Distribution, www.cbsd.com</span></p>
<p class="body_ni"><span>All other countries, Publishers Group Worldwide, www.pgw.com</span></p>
<p> </p>
<p class="body_ni"><span>This book was published with the generous support of Lannan Foundation and Wallace Action Fund.</span></p>
<p> </p>
<p class="body_ni"><span>Cover design by Josh On. Cover photo of the aircraft carrier</span> <em class="italic">USS Ronald Reagan</em> <span>on the Pacific Ocean. Photo by U.S. Navy Mass Communication Specialist 3rd Class Dylan McCord.</span></p>
<p> </p>
<p class="body_ni"><span>Library of Congress Cataloging-in-Publication data is available.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?f361ea9e